import React, { Component } from 'react'

import './_switchButton.css'

class SwitchButton extends Component {
  static defaultProps = {
    items: [],
    onValueChanged: () => { 
      console.log("SwitchButton: 'onValueChanged' handler is not defined!") 
    }
  }

  constructor(props) {
    super(props)
    this.state = { selected: this.props.selected }
  }

  handleChange = (event) => {
    const newValue = parseInt(event.target.dataset.value, 10)
    this.setState({ selected: newValue })
    this.props.onValueChanged(newValue);
  }

  render() {

    const { items } = this.props
    const { selected } = this.state

    return(
      <div className="switch-button">
        {items.map(item => {
          return <button 
            key={item.id}
            data-value={item.id}
            onClick={this.handleChange}
            className={`switch-handle ${(selected === item.id) ? 'selected' : ''}`}>
              {item.value}
            </button>
        })}
      </div>
    )
  }
}

export default SwitchButton


// WEBPACK FOOTER //
// ./src/components/switch-button/SwitchButton.js